 import { Dependencies } from "./dependencies.model"

 export class Service {
  public id: number;
  public url: string;
  public name: string;
  public duration: number;
  public parentId: number;
  public dependencies: Dependencies;
  public parent: Service;
  public parentDependencies: Dependencies;


  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;
    this.url = obj && obj.url || null;
    this.name = obj && obj.name || null;
    this.duration = obj && obj.duration || null;
    this.parentId = obj && obj.parentId || null;
    this.dependencies = obj && obj.dependencies || null;
    this.parentDependencies = obj && obj.parentDependencies || null;
    this.parent = obj && obj.parent || null;
  }
}
